/*
 * This file is generated by generate_bundler_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {PropertyDetailView} from "../../property/views/PropertyDetailView";
const route = [{bundlerEntry: "propertyDetail", path: rpAppPath.property.detail.base, component: PropertyDetailView}];

(function () {
    rpClient(route);
})();
/*
 * This file is generated by generate_bundler_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {PropertyDetailView} from "../../property/views/PropertyDetailView";
const route = [{bundlerEntry: "propertyDetail", path: rpAppPath.property.detail.base, component: PropertyDetailView}];

(function () {
    rpClient(route);
})();
